export const VALUE_SLIDER_WRAPPER = ['relative', 'h-5', 'rounded-full'].join(' ');

export const VALUE_SLIDER_BACKGROUND = [
  'absolute',
  'left-2',
  'right-2',
  'top-1/2',
  'z-0',
  'h-3',
  '-translate-y-1/2',
  'overflow-hidden',
  'rounded-full'
].join(' ');

export const VALUE_SLIDER_BACKGROUND_IMAGE =
  'repeating-conic-gradient(var(--color-accent-light-gray) 0% 25%, transparent 0% 50%)';

export const VALUE_SLIDER_BACKGROUND_SIZE = '8px 8px';

export const VALUE_SLIDER_GRADIENT = [
  'absolute',
  'left-2',
  'right-2',
  'top-1/2',
  'z-10',
  'h-3',
  '-translate-y-1/2',
  'rounded-full',
  'bg-gradient-to-r',
  'from-primary-black',
  'via-transparent',
  'to-primary-white'
].join(' ');

export const VALUE_SLIDER_RANGE_INPUT = [
  'range-exposure',
  'absolute',
  'inset-0',
  'z-10',
  'h-5',
  'w-full',
  'cursor-pointer',
  'appearance-none',
  'bg-transparent'
].join(' ');
